module.exports = __webpack_public_path__ + "img/20190604161639QQ截图20190603170338.6f96a2a9.png";